import { cn } from '@/utils';
import React from 'react';

type Props = React.HTMLAttributes<HTMLDivElement>;

const Spinner = ({
  className,
  iconClassName,
  ...props
}: Props & { iconClassName?: string }) => {
  return (
    <div className={cn('flex text-primary size-5', className)} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={cn('h-full w-full animate-spin', iconClassName)}
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
    </div>
  );
};

export { Spinner };
